module.exports = "/_next/static/images/bfafee613063d41fcc63a335e5d9e9b4-people-smile-at-home-lg@3x.jpg";